export default __webpack_public_path__ + "static/media/promos.77ee17c1.webp";